"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./view");
require("./login-modal");
exports.default = angular.module('rinca.core.main', [
    'rinca.core.main.view',
    'rinca.core.main.login'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/index.ts
// module id = 285
// module chunks = 0